<template>
  <b-modal
    v-model="isModalVisible"
    size="md"
    centered
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
  >
    <vue-croppie
      ref="croppie"
      :enableOrientation="false"
      :enableResize="false"
      :boundary="{
        width: width,
        height: height,
      }"
      :viewport="{
        width: width,
        height: height,
      }"
    >
    </vue-croppie>

    <b-row class="mt-3">
      <b-col cols="12" md="6">
        <b-button pill block variant="info" @click="onCrop"> Crop </b-button>
        <div class="mb-3 d-md-none"></div>
      </b-col>

      <b-col cols="12" md="6">
        <b-button
          pill
          block
          @click="isModalVisible = false"
          variant="outline-info"
        >
          Cancel
        </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 300,
    },
    value: {
      type: [Boolean, Number],
      required: true,
    },
    dataUrl: {
      type: String,
      required: true,
    },
  },

  computed: {
    isModalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    isModalVisible: {
      async handler(isVisible) {
        if (!isVisible) {
          return;
        }

        await this.$nextTick();
        this.$refs.croppie.bind({
          url: this.dataUrl,
        });
      },
      immediate: true,
    },
  },

  methods: {
    onCrop() {
      const options = {
        format: "jpeg",
      };

      this.$refs.croppie.result(options, (dataUrl) => {
        this.$emit("crop", dataUrl);
        this.isModalVisible = false;
      });
    },
  },
};
</script>
